import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {CountriesSearch} from '../../../models/countries-search.interface';
import {REGIONS} from '../../../../constants/constants';

@Component({
  selector: 'app-countries-filter',
  templateUrl: './countries-filter.component.html',
  styleUrls: ['./countries-filter.component.scss']
})
export class CountriesFilterComponent implements OnInit {

  regions = REGIONS;

  searchForm = this.formBuilder.group({
    code: [''],
    name: [''],
    region: [],
    status: [2]
  });

  get codeControl(): FormControl {
    return this.searchForm.get('code') as FormControl;
  }
  get nameControl(): FormControl {
    return this.searchForm.get('name') as FormControl;
  }
  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<CountriesSearch> = new EventEmitter<CountriesSearch>();


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: CountriesSearch = {
      code: this.codeControl.value,
      name: this.nameControl.value,
      region: this.regionControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
